module.exports = __webpack_public_path__ + "static/media/flash-success.9fbb417b.svg";